import { useEffect, useState } from "react";
import PMPExcludedEditIcon from "./pmpExcludedEditIcon";
import PMPExcludedModal from "./pmpExcludedModal";

import { PMPExcludeEditFieldProps } from "./types";
import { useRequest } from "ahooks";
import procedureListService from "service/procedureList";
import { bindUnloadUnlock } from "utils/lockUnload";

export default function PMPExcludedEditField(props: PMPExcludeEditFieldProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditDisabled, setIsEditDisabled] = useState(false);

  const {
    setProcedureIdToList,
    dataList,
    procedureTaskId,
    procedureId,
    procedureAccountId,
    isDisabled,
    pmpExcluded,
    refreshProcedureList,
    uniqueKey,
  } = props;

  const { run: runGetSectionLock } = useRequest(procedureListService.setSectionLock, {
    manual: true,
  });

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    runGetSectionLock({
      procedureId: uniqueKey,
      procedureSectionType: "PMPExcluded",
      setLock: false,
      timeOutMins: 20,
    });
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (!isModalOpen) return;

    return bindUnloadUnlock(
      () => true,
      () =>
        procedureListService.releaseLockOnUnload({
          procedureId: uniqueKey,
          procedureSectionType: "PMPExcluded",
        })
    );
  }, [isModalOpen, uniqueKey]);

  const toggleEditIcon = (flag: boolean) => {
    setIsEditDisabled(flag);
  };

  return (
    <div>
      <PMPExcludedEditIcon
        handleModalOpen={handleModalOpen}
        disabled={isDisabled}
        isEditDisabled={isEditDisabled}
        procedureTaskId={procedureTaskId}
        procedureId={procedureId}
        uniqueKey={uniqueKey}
        procedureAccountId={procedureAccountId}
        pmpExcluded={pmpExcluded}
        refreshProcedureList={refreshProcedureList}
      />

      <PMPExcludedModal
        isModalOpen={isModalOpen}
        handleCloseModal={handleCloseModal}
        procedureTaskId={procedureTaskId}
        procedureId={procedureId}
        toggleEditIcon={toggleEditIcon}
        pmpExcluded={pmpExcluded}
        setProcedureIdToList={setProcedureIdToList}
        dataList={dataList}
      />
    </div>
  );
}
